import React from 'react'
import { Route, Switch, Redirect } from "react-router";
import Error from '../Error';
// import Ordergrocery from '../Ordergrocery';
import Cart from './Cart';
import Product from './Product';
import Orderhistory from '../Orderhistory';
import Orders from '../Orders';
import OrderDetails from '../OrderDetails';
import Events from '../Events';
import Ordergrocerymainmenu from '../Ordergrocerymainmenu';
import Googlebuttoncomponent from '../googlebutton.component';
import ApiTest from '../ApiTest';
import EventsComponent from "../Home/Events";

// import Shoppingcart from '../Shoppingcart';

export const Routes = ({ productItems, cartItems, orderDetail,handleOrderSelection , handleAddProduct, handleRemoveProduct, handleCartClearance }) => {

    return (
        <div className='main-body'>
            <Switch>
                <Route path='/' exact>
                    <Redirect to="/Product" />
                    {/* <Product productItems={productItems} handleAddProduct={handleAddProduct}/> */}
                    <Product />
                </Route>
                <Route path='/Events'>
                    {
                        <EventsComponent />
                    }
                </Route>
                <Route path='/Product' exact>
                    {<Product productItems={productItems} handleAddProduct={handleAddProduct} cartItems={cartItems} />}
                    {/* <Product /> */}
                </Route>
                <Route path='/Cart' exact>
                    <Cart cartItems={cartItems} handleAddProduct={handleAddProduct} handleRemoveProduct={handleRemoveProduct} handleCartClearance={handleCartClearance} />
                </Route>
                <Route path='/Orders' exact>
                    <Orders handleOrderSelection ={handleOrderSelection} />
                </Route>
                <Route path='/OrderDetails' exact>
                    <OrderDetails order={orderDetail} />
                </Route>
                <Route path='/Events' exact>
                    <Events />
                </Route>
                <Route path='/Orderhistory' exact>
                    <Orderhistory />
                </Route>
                <Route path='/Ordergrocerymainmenu' exact>
                    <Ordergrocerymainmenu />
                </Route>
                <Route path='/Login' exact>
                    <Googlebuttoncomponent />
                </Route>
                <Route path='/ApiTest'>
                    <ApiTest />
                </Route>
                <Route>
                    <Error />
                </Route>
                {/* <Route path="/Shoppingcart" exact>
                    <Shoppingcart  Grocerymenu = {items} catItems={catItems} handleAddProduct={handleAddProduct}/>
                </Route>
                <Route path="/Ordergrocery" exact>
                    <Ordergrocery Grocerymenu = {items} catItems={catItems} handleAddProduct={handleAddProduct}/>
                </Route> */}
                {/* <Route exact path="/Events" component={Events} /> */}
                {/* <Route path="/Ordergrocery" component={Ordergrocery} Grocerymenu = {items} catItems={catItems} handleAddProduct={handleAddProduct}/> */}
                {/* <Route path="/Orderhistory" component={Orderhistory} /> */}
                {/* <Route path="/Orders" component={Orders} /> */}
                {/* <Route path="/Shoppingcart" component={Shoppingcart} Grocerymenu = {items} catItems={catItems} handleAddProduct={handleAddProduct}/> */}


            </Switch>
        </div>
    )
}

export default Routes;